import React from 'react';
import { StepperTW } from 'tailwindComponents/stepper/StepperTW';
import { CreateSigningAppointmentFormData } from '../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { eSigningMethod } from 'types/signingAppointment/eSigningMethod';

export enum ProgressStep {
  DETAILS,
  SIGNERS,
  METHOD,
  CONFIRMATION,
}

const labels: string[] = ['Details', 'Signers', 'Method', 'Confirmation'];
const labelsWithoutNotary: string[] = ['Details', 'Signers', 'Confirmation'];

export const WizardProgress: React.FC<{ step: ProgressStep; wizardFormData: CreateSigningAppointmentFormData }> = ({
  step,
  wizardFormData,
}) => {
  if (
    wizardFormData.isSignatureSyncAppointment ||
    (wizardFormData.isDigitalScheduling && wizardFormData.signingMethod === eSigningMethod.notaryOnly)
  ) {
    return <StepperTW current={step} labels={labelsWithoutNotary} />;
  }
  return <StepperTW current={step} labels={labels} />;
};
